import { useQuery } from '@tanstack/react-query';

import { apiClient } from 'shared/client/apiClient';
import { LearningObjectSnapshot } from 'shared/types/LearningObjects';

export const learningActivitySnapshotByIdQueryKey = (learningActivitySnapshotId?: string) =>
  ['learning-activity-snapshot', { learningActivitySnapshotId }] as const;

export const getLearningActivitySnapshotById = async ({
  learningActivitySnapshotId
}: {
  learningActivitySnapshotId?: string;
}) => {
  if (!learningActivitySnapshotId) {
    throw new Error('No `learningActivitySnapshotId`');
  }

  const { data } = await apiClient.GET('/learning-activity-snapshots/{learningActivitySnapshotId}', {
    params: { path: { learningActivitySnapshotId } }
  });
  return data as any; //FIXME provide return type;
};

export const useGetLearningActivitySnapshotByIdQuery = (learningActivitySnapshotId?: string) => {
  return useQuery<LearningObjectSnapshot>({
    queryKey: learningActivitySnapshotByIdQueryKey(learningActivitySnapshotId),
    queryFn: () => getLearningActivitySnapshotById({ learningActivitySnapshotId }),
    enabled: !!learningActivitySnapshotId
  });
};
